
const createYear = () => {
  const old = 1900;
  const current = new Date().getFullYear();
  const length = current - old;
  let years = `<option value="0" selected>年</option>`;
  for (let i = 0; i <= length; i++) {
    let html = `<option value=${old + i}>${old + i}</option>`;
    years = years + html;
  }
  years = new DOMParser().parseFromString(years, "text/html");
  return years;
}
const createDate = (day, placeholder) => {
  let dom = `<option value="0" selected>${placeholder}</option>`;
  for (let i = 1; i <= day; i++) {
    let html = "";
    if (i <= 9) {
      html = `<option value=0${i}>0${i}</option>`;
    } else {
      html = `<option value=${i}>${i}</option>`;
    }
    dom = dom + html;
  }
  dom = new DOMParser().parseFromString(dom, "text/html");
  return dom;
}
const valueChangeEvent = ([...args], attribute) => {
  let year = null;
  let month = null;
  let day = null;
  for (const element of args) {
    const options = element.querySelectorAll('option');
    const hidden = document.querySelector('.js-input-hidden');
    element.addEventListener('change', () => {
      element.selectedIndex === 0 ? element.style.color = '#ccc' : element.style.color = 'rgb(var(--inputColor))';
      switch (element) {
        case select1:
          year = options[element.selectedIndex].value;
          break;
        case select2:
          month = options[element.selectedIndex].value;
          break;
        case select3:
          day = options[element.selectedIndex].value;
          break;
      }
      const value = year.concat('-', month, '-', day);
      if (!value.includes('null')) hidden.value = value;
      if (hidden.value && attribute) hidden.setAttribute('name', attribute);
    });
  }
}

const variable = (str) => { return document.querySelector(`.js-select-${str}`) };
